import http from '@/utils/http'
import httpApi from '@/apis/httpApi'

export const getResetPwd=({password,smsCode,verifyPassword})=>{
    return http.post({
        url:httpApi.safe.getResetPwd,
        data:{
            password,
            smsCode,
            verifyPassword
        }
    })
}

export const getResetSms=({imgCode})=>{
    return http.post({
        url:httpApi.safe.getResetSms,
        data:{
            imgCode
        }
    })
}
// 获取原手机短信
export const getRestPhoneOldSms=({imgCode})=>{
    return http.post({
        url:httpApi.safe.getRestPhoneOldSms,
        data:{
            imgCode
        }
    })
}
// 验证原手机号
export const resetPhoneValidateOld=({smsCode})=>{
    return http.post({
        url:httpApi.safe.resetPhoneValidateOld,
        data:{
            smsCode
        }
    })
}
// 获取新手机短信
export const getResetPhoneNewSms=({newPhone,imgCode})=>{
    return http.post({
        url:httpApi.safe.getResetPhoneNewSms,
        data:{
            newPhone,
            imgCode
        }
    })
}
// 修改绑定手机
export const resetPhone=({newPhone,smsCode})=>{
    return http.post({
        url:httpApi.safe.resetPhone,
        data:{
            newPhone,
            smsCode
        }
    })
}
// 开启/关闭短信验证——1.获取短信
export const getSaveTypeSms=({imgCode})=>{
    return http.post({
        url:httpApi.safe.getSaveTypeSms,
        data:{
            imgCode
        }
    })
}
// 开启/关闭短信验证——2.开启/关闭
export const saveValidateType=({saveType,smsCode})=>{
    return http.post({
        url:httpApi.safe.saveValidateType,
        data:{
            saveType,
            smsCode
        }
    })
}
// 微信发送短信验证码
export const sendWxSmsCode=()=>{
    return http.post({
        url:httpApi.safe.sendWxSmsCode,
        data:{
        }
    })
}
// 验证微信短信验证码
export const validateWxSmsCode=({smsCode})=>{
    return http.post({
        url:httpApi.safe.validateWxSmsCode,
        data:{
            smsCode
        }
    })
}

export const getBindWx=({code,state})=>{
    return http.post({
        url:httpApi.safe.getBindWx,
        data:{
            code,
            state
        }
    })
}

export const getUnbindWx=()=>{
    return http.post({
        url:httpApi.safe.getUnbindWx,
        data:{

        }
    })
}